import { ViewBox } from "./view";
import { EditBox } from "./edit";

const Box = ({ box, withStatus, edit = false, ...props }) => {
    if (edit && !['returned', 'not_picked_up'].includes(box.status)) {
        return <EditBox withStatus={withStatus} box={box} {...props} />;
    }

    return <ViewBox box={box} withStatus={withStatus} {...props} />;
};

const Boxes = ({ edit, customer, boxes, withStatus = true }) => {

    const Display = () => {
        if (boxes.length === 0) {
            return (
                <div className="box has-background-light">
                    <article className="message p-6">
                        <div className="message-body">
                            This customer did not receive any boxes yet.
                        </div>
                    </article>
                </div>
            );
        }

        return (
            <>
                {boxes.map((box, index) => (
                    <div key={box.id} className="box">
                        <Box edit={edit} box={box} number={boxes.length - index} customer={customer} withStatus={withStatus} />
                    </div>
                ))}
            </>
        )
    }

    return (
        <div className="container">
            <h1 className="title">Boxes</h1>
            <Display />
        </div>
    );
};

export { Box, Boxes };
